import { amenityService } from '../clients/ApiClients';

/**
 * The association the all-associations reservation calendar opens on:
 * the one chosen last time if it is still visible, else the first active
 * association with a bookable amenity (asked one at a time, stopping at
 * the first), else the first active one.
 *
 * Before this the calendar opened on the alphabetically first association,
 * which could be inactive or have no amenities — an empty grid that read
 * as "nothing is booked".
 */
export const pickCalendarHoa = async (
  hoas: { id: string; is_active?: boolean | null }[],
  remembered: string | null,
  hasBookable: (hoaId: string) => Promise<boolean> = async (id) =>
    (await amenityService.listAmenities({ hoaId: id })).data.amenities.some(
      (a) => a.is_active && a.booking_mode !== 'info_only'
    )
): Promise<string | null> => {
  if (remembered && hoas.some((h) => h.id === remembered)) return remembered;
  const active = hoas.filter((h) => h.is_active !== false);
  for (const h of active) {
    try {
      if (await hasBookable(h.id)) return h.id;
    } catch {
      // An association we cannot read is skipped, not fatal.
    }
  }
  return active[0]?.id ?? hoas[0]?.id ?? null;
};
